var React = require('react');

function Reset (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.11361 0.19163C0.858925 -0.0630656 0.445992 -0.0630745 0.191297 0.19161C-0.0633986 0.446294 -0.0634076 0.859227 0.191277 1.11392L4.07754 5.00035L0.191008 8.88705C-0.0636774 9.14175 -0.0636683 9.55468 0.191027 9.80937C0.445722 10.064 0.858656 10.064 1.11334 9.80935L4.99987 5.92265L8.88639 9.80935C9.14108 10.064 9.55401 10.0641 9.8087 9.80937C10.0634 9.55468 10.0634 9.14175 9.80872 8.88705L5.92246 5.00062L9.80899 1.11392C10.0637 0.859229 10.0637 0.446296 9.80897 0.191611C9.55428 -0.0630729 9.14135 -0.0630641 8.88666 0.191631L5.00013 4.07832L1.11361 0.19163Z","fill":"#4C0FFB"}));
}

Reset.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = Reset;

Reset.default = Reset;
